import React from 'react'
import ValidateCSV from './Components/ValidateCSV';

const App = () => {
  return (
      <>
      <ValidateCSV/>
      </>
  )
}

export default App